<template>
    <div class="news-horizon-container">
        <div class="news-img" @click="toViewDetail">
            <ImageCard :src="newsInfo.cover" />
        </div>
        <div class="news-content">
            <div class="title" @click="toViewDetail">{{ newsInfo.title }}</div>
            <div class="content">{{ newsInfo.description }}</div>
            <div class="create-readnum">
                <div>{{ newsInfo.created_at | formatDate }}</div>
                <div>{{ newsInfo.view_count }}人看过</div>
            </div>
        </div>
    </div>
</template>

<script>
    import ImageCard from "@/components/ImageCard"
    export default {
        props: {
            newsInfo: {
                type: Object,
                default: {}
            }
        },
        components: { ImageCard },
        data() {
            return {}
        },
        methods: {
            toViewDetail() {
                this.$emit('toViewDetail', this.newsInfo)
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/styles/mixin.less";
    @import "~@/styles/var.less";

    .news-horizon-container {
        width: 100%;
        display: flex;
    }

    .news-horizon-container:not(:first-child) {
        margin-top: 25px;
    }

    .news-img {
        width: 250px;
        height: 100px;
        border-radius: 10px;
        overflow: hidden;
        margin-right: 28px;
        cursor: pointer;
    }

    .news-img img {
        width: 100%;
        height: 100%;
    }

    .news-content {
        flex: 1;
    }

    .title {
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 600;
        color: @words;
        margin-bottom: 12px;
        cursor: pointer;
    }

    .content {
        font-size: 12px;
        font-weight: 400;
        color: @darkwords;
        margin-bottom: 15px;
        .line-clamp()
    }

    .create-readnum {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-weight: 400;
        color: @tipwords;
    }
</style>